<template>
  <div class="app-empty-state" :class="{ 'app-empty-state--onboarding': tone === 'onboarding' }">
    <v-icon class="app-empty-state__icon" size="22">{{ icon }}</v-icon>
    <p class="app-empty-state__title text-body-2">{{ title }}</p>
    <p v-if="description" class="app-empty-state__description text-body-2">{{ description }}</p>
    <div v-if="$slots.default" class="app-empty-state__actions">
      <slot />
    </div>
  </div>
</template>

<script>
/**
 * Empty state standard (docs/design/ui-kit.md → Empty state): iconiță MDI discretă, un rând care spune
 * ce lipsește, opțional un rând cu ce poate face utilizatorul și acțiunea următoare în slot
 * (`v-btn` sau link de configurare). `tone="onboarding"` folosește fundalul cald pentru primele stări goale.
 */
export default {
  name: "AppEmptyState",
  props: {
    icon: { type: String, default: "mdi-inbox-outline" },
    title: { type: String, required: true },
    description: { type: String, default: "" },
    tone: { type: String, default: "neutral", validator: (value) => ["neutral", "onboarding"].includes(value) },
  },
};
</script>

<style scoped>
.app-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--app-space-2);
  padding: var(--app-space-8) var(--app-space-4);
  text-align: center;
}

.app-empty-state--onboarding {
  border-radius: var(--app-radius-base);
  background: var(--app-warm-highlight-soft-bg);
}

.app-empty-state__icon {
  opacity: 0.6;
}

.app-empty-state__title,
.app-empty-state__description {
  margin: 0;
}

.app-empty-state__title {
  color: var(--app-text-strong);
  font-weight: 600;
}

.app-empty-state__description {
  max-width: 420px;
  opacity: 0.75;
}

.app-empty-state__actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: var(--app-space-2);
  margin-top: var(--app-space-2);
}
</style>
